module.exports = __webpack_public_path__ + "01_long_black.94483ddc.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/okuta/dad/layer5/01_long_black.png
// module id = fhGp
// module chunks = 0